import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import { ITabViewChild, ITabViewProps } from '../../../../components/TabView';
import { styleSheet } from './styles';

const ReportingTypeTabIndexMap = {
	[Api.BulkEmailReportType.Campaigns]: 0,
	[Api.BulkEmailReportType.IndividualEmails]: 1,
	[Api.BulkEmailReportType.Automations]: 2,
};

const BASE_TABS: ITabViewChild<Api.BulkEmailReportType>[] = [
	{
		tabbarItem: {
			content: 'Campaigns',
			dataContext: Api.BulkEmailReportType.Campaigns,
		},
	},
	{
		tabbarItem: {
			content: 'Individual Emails',
			dataContext: Api.BulkEmailReportType.IndividualEmails,
		},
	},
];

export function useEmailReportingTabs({
	selectedCampaignReportType,
	onTabSelectionChanged,
}: {
	selectedCampaignReportType: Api.BulkEmailReportType;
	onTabSelectionChanged: (type: Api.BulkEmailReportType) => void;
}) {
	const userSession = useUserSession();
	const [tabs] = React.useState(() => {
		return [
			...BASE_TABS,
			userSession.account.features?.automation?.enabled
				? {
						tabbarItem: {
							content: 'Upcoming Automations',
							dataContext: Api.BulkEmailReportType.Automations,
						},
					}
				: null,
		].filter(Boolean) as ITabViewChild<Api.BulkEmailReportType>[];
	});
	const onTabSelected = (_selectedTabIndex: number) => {
		const _selectedCampaignReportType =
			_selectedTabIndex === 0
				? Api.BulkEmailReportType.Campaigns
				: _selectedTabIndex === 1
					? Api.BulkEmailReportType.IndividualEmails
					: Api.BulkEmailReportType.Automations;
		onTabSelectionChanged(_selectedCampaignReportType);
	};

	const getTabViewProps = (props?: Partial<ITabViewProps>): ITabViewProps => {
		return {
			className: css(styleSheet.tabViewContainer),
			contentClassName: css(styleSheet.tabViewContent),
			hasFixedHeaders: true,
			itemClassName: css(styleSheet.tabViewItem),
			onSelectedTabIndexChanged: onTabSelected,
			selectedItemClassName: css(styleSheet.tabViewSelectedItem),
			selectedTabIndex: ReportingTypeTabIndexMap[selectedCampaignReportType] || 0,
			selectedTabIndicator: css(styleSheet.tabViewSelectedTabIndicator),
			tabbarClassName: css(styleSheet.tabViewTabbar),
			tabbarTabsClassName: css(styleSheet.tabViewTabs),
			usesScrollView: false,
			...props,
		};
	};

	return {
		getTabViewProps,
		tabs,
	};
}
